module.exports = __webpack_public_path__ + "static/gw-supporters-01-2e22ff92bd50310c1412bf593b0b28e6.png";